import { createDemo } from '@mui/internal-core-docs/utils/createDemo';
import CustomizedBreadcrumbs from './CustomizedBreadcrumbs';
import ClientProvider from './client';
export default createDemo(import.meta.url, CustomizedBreadcrumbs, { ClientProvider, precompute: {
  "Default": {
    "url": "file:///opt/build/repo/docs/data/material/components/breadcrumbs/demos/customized/CustomizedBreadcrumbs.tsx",
    "fileName": "CustomizedBreadcrumbs.tsx",
    "language": "tsx",
    "source": {
      "type": "root",
      "children": [
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "import * as React from 'react';\nimport { emphasize, styled } from '@mui/material/styles';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Chip from '@mui/material/Chip';\nimport HomeIcon from '@mui/icons-material/Home';\nimport ExpandMoreIcon from '@mui/icons-material/ExpandMore';\n\nconst StyledBreadcrumb = styled(Chip)(({ theme }) => {\n  return {\n    backgroundColor: theme.palette.grey[100],\n    height: theme.spacing(3),\n    color: (theme.vars || theme).palette.text.primary,\n    fontWeight: theme.typography.fontWeightRegular,\n    '&:hover, &:focus': {\n      backgroundColor: emphasize(theme.palette.grey[100], 0.06),\n      ...theme.applyStyles('dark', {\n        backgroundColor: emphasize(theme.palette.grey[800], 0.06),\n      }),\n    },\n    '&:active': {\n      boxShadow: theme.shadows[1],\n      backgroundColor: emphasize(theme.palette.grey[100], 0.12),\n      ...theme.applyStyles('dark', {\n        backgroundColor: emphasize(theme.palette.grey[800], 0.12),\n      }),\n    },\n    ...theme.applyStyles('dark', {\n      backgroundColor: theme.palette.grey[800],\n    }),\n  };\n}) as typeof Chip; // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591\n\nfunction handleClick(event: React.MouseEvent<Element, MouseEvent>) {\n  event.preventDefault();\n  console.info('You clicked a breadcrumb.');\n}\n\nexport default function CustomizedBreadcrumbs() {\n  return (\n    <div role=\"presentation\" onClick={handleClick}>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "dataFrameType": "focus",
            "dataFrameIndent": 3,
            "dataFrameFocusTarget": "",
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "      <Breadcrumbs aria-label=\"breadcrumb\">\n        <StyledBreadcrumb\n          component=\"a\"\n          href=\"#\"\n          label=\"Home\"\n          icon={<HomeIcon fontSize=\"small\" />}\n        />\n        <StyledBreadcrumb component=\"a\" href=\"#\" label=\"Catalog\" />\n        <StyledBreadcrumb\n          label=\"Accessories\"\n          deleteIcon={<ExpandMoreIcon />}\n          onDelete={handleClick}\n        />\n      </Breadcrumbs>\n"
            }
          ]
        },
        {
          "type": "element",
          "tagName": "span",
          "properties": {
            "className": [
              "frame"
            ]
          },
          "children": [
            {
              "type": "text",
              "value": "    </div>\n  );\n}\n"
            }
          ]
        }
      ],
      "data": {
        "totalLines": 57,
        "focusedLines": 14,
        "collapsible": true
      }
    },
    "fallback": [
      [
        "span",
        "frame",
        "import * as React from 'react';\nimport { emphasize, styled } from '@mui/material/styles';\nimport Breadcrumbs from '@mui/material/Breadcrumbs';\nimport Chip from '@mui/material/Chip';\nimport HomeIcon from '@mui/icons-material/Home';\nimport ExpandMoreIcon from '@mui/icons-material/ExpandMore';\n\nconst StyledBreadcrumb = styled(Chip)(({ theme }) => {\n  return {\n    backgroundColor: theme.palette.grey[100],\n    height: theme.spacing(3),\n    color: (theme.vars || theme).palette.text.primary,\n    fontWeight: theme.typography.fontWeightRegular,\n    '&:hover, &:focus': {\n      backgroundColor: emphasize(theme.palette.grey[100], 0.06),\n      ...theme.applyStyles('dark', {\n        backgroundColor: emphasize(theme.palette.grey[800], 0.06),\n      }),\n    },\n    '&:active': {\n      boxShadow: theme.shadows[1],\n      backgroundColor: emphasize(theme.palette.grey[100], 0.12),\n      ...theme.applyStyles('dark', {\n        backgroundColor: emphasize(theme.palette.grey[800], 0.12),\n      }),\n    },\n    ...theme.applyStyles('dark', {\n      backgroundColor: theme.palette.grey[800],\n    }),\n  };\n}) as typeof Chip; // TypeScript only: need a type cast here because https://github.com/Microsoft/TypeScript/issues/26591\n\nfunction handleClick(event: React.MouseEvent<Element, MouseEvent>) {\n  event.preventDefault();\n  console.info('You clicked a breadcrumb.');\n}\n\nexport default function CustomizedBreadcrumbs() {\n  return (\n    <div role=\"presentation\" onClick={handleClick}>\n"
      ],
      [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        "      <Breadcrumbs aria-label=\"breadcrumb\">\n        <StyledBreadcrumb\n          component=\"a\"\n          href=\"#\"\n          label=\"Home\"\n          icon={<HomeIcon fontSize=\"small\" />}\n        />\n        <StyledBreadcrumb component=\"a\" href=\"#\" label=\"Catalog\" />\n        <StyledBreadcrumb\n          label=\"Accessories\"\n          deleteIcon={<ExpandMoreIcon />}\n          onDelete={handleClick}\n        />\n      </Breadcrumbs>\n"
      ],
      [
        "span",
        "frame",
        "    </div>\n  );\n}\n"
      ]
    ],
    "fallbackCritical": {
      "1": [
        "span",
        "frame",
        {
          "dataFrameType": "focus",
          "dataFrameIndent": 3,
          "dataFrameFocusTarget": ""
        },
        [
          [
            "span",
            "line",
            {
              "dataLn": 41
            },
            [
              "      <",
              [
                "span",
                "pl-c1 di-jsx",
                "Breadcrumbs"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "aria-label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "breadcrumb",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              ">"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 42
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "StyledBreadcrumb"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 43
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "component"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "a",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 44
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "#",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 45
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Home",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 46
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "icon"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "HomeIcon"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "fontSize"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "small",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 47
            },
            "        />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 48
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "StyledBreadcrumb"
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "component"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "a",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "href"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "#",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Catalog",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ],
              " />"
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 49
            },
            [
              "        <",
              [
                "span",
                "pl-c1 di-jsx",
                "StyledBreadcrumb"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 50
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "label"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-s di-av",
                [
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ],
                  "Accessories",
                  [
                    "span",
                    "pl-pds",
                    "\""
                  ]
                ]
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 51
            },
            [
              "          ",
              [
                "span",
                "pl-e di-ak",
                "deleteIcon"
              ],
              [
                "span",
                "pl-k di-pu di-ae",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              "<",
              [
                "span",
                "pl-c1 di-jsx",
                "ExpandMoreIcon"
              ],
              " />",
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 52
            },
            [
              "          ",
              [
                "span",
                "pl-e",
                "onDelete"
              ],
              [
                "span",
                "pl-k di-pu",
                "="
              ],
              [
                "span",
                "pl-pse",
                "{"
              ],
              [
                "span",
                "pl-smi",
                "handleClick"
              ],
              [
                "span",
                "pl-pse",
                "}"
              ]
            ]
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 53
            },
            "        />"
          ],
          "\n",
          [
            "span",
            "line",
            {
              "dataLn": 54
            },
            [
              "      </",
              [
                "span",
                "pl-c1 di-jsx",
                "Breadcrumbs"
              ],
              ">"
            ]
          ],
          "\n"
        ]
      ]
    },
    "totalLines": 57,
    "focusedLines": 14,
    "collapsible": true,
    "externals": [
      "react",
      "@mui/material/styles",
      "@mui/material/Breadcrumbs",
      "@mui/material/Chip",
      "@mui/icons-material/Home",
      "@mui/icons-material/ExpandMore"
    ]
  }
}, loadPrecompute: () => import("./index.ts?mui-deferred-precompute").then((module) => module.default) });
